import { notification } from "antd";
import {
  FETCH_STATISTICS_REQUEST,
  FETCH_STATISTICS_SUCCESS,
  FETCH_STATISTICS_FAILURE,
} from "../Types";
import { apiGet } from "../../services/apiInterceptor";

export const fetchStatistics = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_STATISTICS_REQUEST });

    try {
      // ✅ MIGRATION : Plus besoin de gérer manuellement le token et les headers
      const response = await apiGet("api/forms/general/stats");

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.message || "Erreur lors de la récupération des statistiques."
        );
      }

      dispatch({ type: FETCH_STATISTICS_SUCCESS, payload: data });
      return data;
    } catch (error) {
      dispatch({ type: FETCH_STATISTICS_FAILURE, payload: error?.message });

      notification.error({
        message: error?.message || "Échec de la récupération des statistiques.",
        duration: 5,
      });
    }
  };
};
